import type { CommandDeparture } from './types';

export function tourLinks(
  rows: Array<CommandDeparture>,
  portalHost: string,
): { admin: string | null; site: string | null } {
  const row = rows.find((departure) => departure.tour_id);
  if (!row?.tour_id) {
    return { admin: null, site: null };
  }
  const id = encodeURIComponent(row.tour_id);
  return {
    admin: `/tours/details/tour-${id}`,
    site: !row.is_content_approved ? null : `${portalHost}/tour/tour-${id}`,
  };
}
